let dict = {};
export function setText(next) {
    dict = next;
}
/** The raw template for a key, or `[key]` when the file doesn't have it. */
export const template = (key) => dict[key] ?? `[${key}]`;
/** Does the text file have this key? (For optional entries such as card names.) */
export const hasText = (key) => key in dict;
/** The text for a key, with `{placeholders}` filled in. */
export function t(key, vars) {
    const s = template(key);
    return vars ? s.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m)) : s;
}
/** Counted text: `<key>.one` when `n` is 1, `<key>.other` otherwise; `{n}` is the count. */
export const tn = (key, n, vars) => t(`${key}.${n === 1 ? 'one' : 'other'}`, { n, ...vars });
/** Names or phrases joined into one list, e.g. 'Ann, Bob'. */
export const tList = (items) => items.join(template('list.separator'));
/** An idle limit in minutes, as shown: '30 min', or whole hours as '12 h'. */
export const idleLimitText = (minutes) => minutes >= 60 && minutes % 60 === 0
    ? t('lobby.idleLimit.hours', { n: minutes / 60 })
    : t('lobby.idleLimit.minutes', { n: minutes });
//# sourceMappingURL=text.js.map